import { useEffect } from 'react'
import { useState } from 'react'
import logo from '../../assets/ceramol-acn3-logo.png'
import logo2x from '../../assets/ceramol-acn3-logo@2x.png'
import { Language, useLanguage, useTranslate } from '../../TranslationsContext'
import { Container } from '../Container/Container'
import { SlideDownIcon } from '../ProductsShowcase/SlideDownIcon'
import './Menu.css'

export function Menu() {
  const currentLanguage = useLanguage()
  const translate = useTranslate()
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  useEffect(() => {
    const onResize = () => {
      setWindowWidth(window.innerWidth)
    }

    window.addEventListener('resize', onResize)

    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [])

  const shouldMenuContentBeVisible = windowWidth < 1024

  return (
    <>
      <header className="Menu">
        <Container>
          <img
            src={logo}
            srcSet={`${logo} 1x, ${logo2x} 2x`}
            alt="Ceramol Acn3"
            className="logo"
            height="36"
          />
          {shouldMenuContentBeVisible ? (
            <p className="languages">
              <span>{currentLanguage}</span>
              <SlideDownIcon
                color="#000"
                action={() => setIsMenuOpen(isMenuOpen => !isMenuOpen)}
              />
            </p>
          ) : (
            <p className="languages">
              {Object.keys(Language).map((slug, index) => (
                <span key={slug}>
                  <a
                    className={`${currentLanguage === slug ? 'active' : ''}`}
                    href={`https://acn3.ceramol.${slug}`}
                  >
                    {slug}
                  </a>
                  {index < Object.entries(Language).length - 1 ? (
                    <>&nbsp;/&nbsp;</>
                  ) : (
                    ''
                  )}
                </span>
              ))}
            </p>
          )}
        </Container>
      </header>
      {shouldMenuContentBeVisible && (
        <div className={`MenuContent${isMenuOpen ? ' visible' : ''}`}>
          <div className="content">
            <p>{translate('Menu.chooseYourLanguage')}</p>
            <ul>
              {Object.entries(Language).map(([slug, language]) => (
                <li
                  key={slug}
                  className={slug === currentLanguage ? 'active' : ''}
                >
                  <a href={`https://acn3.ceramol.${slug}`}>{language}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </>
  )
}
